import React from 'react';
import { object } from 'prop-types';
import Media from 'react-bootstrap/lib/Media';
import Row from '@coxautokc/fusion-ui-components/lib/Row';
import Image from 'react-bootstrap/lib/Image';
import CustomerInformationContainer from './CustomerInformationContainer';
import { Customer } from '../../../propTypes';
import './_customerProfile.scss';

function getCompanyDisplay(customerInfo) {
  const companyName = customerInfo && customerInfo.companyName;
  const companyTypeAbbr =
    customerInfo &&
    customerInfo.companyType &&
    customerInfo.companyType.charAt(0);
  return companyName && companyTypeAbbr
    ? `${companyName} (${companyTypeAbbr})`
    : companyName;
}

function getAddressDisplayLines(customerInfo) {
  const address = (customerInfo && customerInfo.address) || {};
  const cityStateZip = [[address.city], [address.state, address.postal]]
    .map(x => x.filter(Boolean).join(' '))
    .filter(Boolean)
    .join(', ');
  return [address.street, address.street2, cityStateZip].filter(Boolean);
}

const CustomerProfile = ({ customer, actions }) => {
  const company = getCompanyDisplay(customer);
  const address = getAddressDisplayLines(customer) || [];

  return (
    <div id="customer-profile">
      <div className="customer-profile">
        <Media className="customer-profile__media">
          <Media.Left className="customer-profile__photo">
            <Image
              className="customer-profile__img"
              src={customer.photo}
              alt={customer.firstName + ' ' + customer.lastName}
            />
          </Media.Left>

          <Media.Body>
            <Row className="customer-profile__info">
              <li>
                <strong>
                  {customer.firstName +
                    ' ' +
                    customer.middleName +
                    ' ' +
                    customer.lastName}
                </strong>
              </li>

              {customer.isCompany && <li>{company}</li>}

              {address.map(line => (
                <li
                  key={line}
                  className={
                    customer.doNotMail && 'customer-profile__strikeThough'
                  }
                >
                  {line}
                </li>
              ))}
            </Row>
          </Media.Body>
        </Media>
      </div>
      <CustomerInformationContainer
        htmlId="customerProfile-customerNameEditContainer"
        customer={customer}
        actions={actions}
      />
    </div>
  );
};

CustomerProfile.propTypes = {
  actions: object.isRequired,
  customer: Customer.isRequired
};

export default CustomerProfile;



// WEBPACK FOOTER //
// ./src/components/pages/MockApiExamplePage/CustomerProfile.js